import { render } from "./PlantNotificationParks.vue?vue&type=template&id=5ba5c589&scoped=true"
import script from "./PlantNotificationParks.vue?vue&type=script&lang=js"
export * from "./PlantNotificationParks.vue?vue&type=script&lang=js"

import "./PlantNotificationParks.vue?vue&type=style&index=0&id=5ba5c589&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ba5c589"]])

export default __exports__